export default () => `
  {
    currentUser {
      orders {
        number
        completedAt

        items {
          productType
          groupName
          imageUrl
          color
          size
          quantity
          displayAmount
          productPath
        }
      }
    }
    paths {
      explorePath
      customerServiceUrl
    }
    returns {
      currentReturnPeriod
    }
  }
`
